import { KeyValuePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { NOTIFICATION_PRIORITY_CONFIG } from '@navfleet/client/fleet/event/domain/models';
import { NAV_ROUTES } from '@navfleet/client/navigation/domain/models';
import { NavRouterLinkDirective } from '@navfleet/client/navigation/utils';
import { IconContainer } from '@navfleet/client/shared/components/icon/ui';
import { TranslationModule } from '@navfleet/shared/core/translation';
import { TooltipModule } from '@openng/optimus-ui/tooltip';

@Component({
    imports: [TranslationModule, IconContainer, TooltipModule, KeyValuePipe, NavRouterLinkDirective],
    selector: 'fl-top-menu-notifications-toolbar',
    templateUrl: './top-menu-notifications-toolbar.component.html',
    styleUrls: ['./top-menu-notifications-toolbar.component.scss'],
})
export class TopMenuNotificationsToolbarComponent {
    public readonly NOTIFICATION_PRIORITY_CONFIG = NOTIFICATION_PRIORITY_CONFIG;
    public readonly NAV_ROUTES = NAV_ROUTES;

    public readonly filteredOutNotifications = input<{ [type: string]: number } | null | undefined>(null);
    public readonly pinned = input<boolean>(false);
    public readonly pinClicked = output();
}
